import { useAppointmentUncheckMutation } from "../../../../../../../api/appointments/useAppointmentUncheckMutation";
import { uiNotification } from "../../../../../../../services/UINotificationService";
import { useContext } from "../context";

export function useCheckout() {
  const { appointment, refetchAppointments } = useContext();

  const { mutateAsync, isLoading } = useAppointmentUncheckMutation({
    onError: () => {
      uiNotification.error("Unable to uncheck appointment. Please try again.");
    },
    onSuccess: () => {
      uiNotification.success("Appointment unchecked successfully.");
      refetchAppointments();
    },
  });

  const initiate = () => {
    return mutateAsync({ appointmentId: appointment.id });
  };

  return {
    initiate,
    isLoading,
  };
}
